import React from "react";
import Menu from "../../Menu";
import Footer from "../../footer";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import Button from "@material-ui/core/Button";
import { Redirect } from "react-router-dom";
import * as Api from "../../api/main";
import LoadingOverlay from "react-loading-overlay";
import { ClipLoader } from "react-spinners";
import { connect } from "react-redux";
import * as UserActions from "../../actions/userDataActions";
import { set_loading } from "../../actions/loadingActions";
import { redirectToStepTwo } from "../../actions/stepOneActions";
import InputMask from "react-input-mask";
import MetaTags from "react-meta-tags";
import ReactGA from "react-ga";
import cookie from "react-cookies";
// import { hotjar } from 'react-hotjar';
import { DetectPartner } from "../../detectPartnerUrl";
import Spinner from "../../helpers/Spinner";

class StepOne extends React.Component {
  constructor(props) {
    super(props);
    this.buttonNext = this.buttonNext.bind(this);
    this.renderRedirect = this.renderRedirect.bind(this);
    this.validator = this.validator.bind(this);
  }

  state = {
    isLoading: false,
  };

  componentDidMount() {
    const ifPartnerexist = cookie.load("partner");
    !ifPartnerexist ? DetectPartner(window.location.search) : null;
    // hotjar.initialize(1592041,6);
    ReactGA.pageview("/registration-step1-new2");
    ValidatorForm.addValidationRule("PhoneChecker", (value) => {
      return this.props.store.userDataReducer.phone.replace(/[\s_\-()]+/g, "").length >= 10;
    });
    ValidatorForm.addValidationRule("RussianSymbolsChecker", (value) => {
      return !(
        value.match(/\d+/) ||
        value.match(/[a-zA-Z]/) ||
        value.length <= 0 ||
        !value.match(/^[А-Яа-яа-щА-ЩЬьЮюЯяЇїІіЄєҐґ(\-)(\ )(\')]+$/)
      );
    });
  }

  async buttonNext() {
    this.setState({ isLoading: true });
    this.props.dispatch(set_loading(true));
    let partner = "";
    let phone = this.props.store.userDataReducer.phone;
    let name = this.props.store.userDataReducer.fio;
    let amount = this.props.store.rangeSliderReduser.range_amount;
    //        let amount = cookie.load('Amount')[0];

    let subpartner = "";
    try {
      const responce = await Api.GetToken(partner, phone, name, amount, subpartner);
      const user_ip = responce.ip;
      console.log(`responce.data.IPv4`, user_ip);
      if (responce) {
        this.setState({ isLoading: false });
        cookie.save("token", responce.data.user_id);
        this.props.dispatch(UserActions.set_token(responce.data.user_id));
        this.props.dispatch(set_loading(false));
        this.props.dispatch(redirectToStepTwo(true));
      }
    } catch (error) {
      this.setState({ isLoading: false });
      console.log(error);
    }
  }

  validator() {}

  renderRedirect = () => {
    if (this.props.store.stepOneReduser.redirectToStepTwo) {
      return (
        <Redirect
          to={{
            pathname: "/registration-step2-new2",
            phone: this.props.store.userDataReducer.phone,
            fio: this.props.store.userDataReducer.fio,
          }}
        />
      );
    }
  };

  render() {
    return (
      <div>
        <MetaTags>
          <title>Заповніть заявку на кредит</title>
          <meta
            name="description"
            content="Войти в личный кабинет ПростоГроші. Регистрация нового клиента в системе, восстановления пароля"
          />
        </MetaTags>
        <Menu />
        <LoadingOverlay
          className="loading"
          text="Триває обробка даних"
          active={this.props.store.loadingReducer.loading}
          spinner={
            <div className="spiner">
              <ClipLoader className="spiner" color={"#fff"} />
            </div>
          }
        />
        {this.renderRedirect()}
        <div className="main-block-registration">
          <h1>Заповніть заявку на кредит</h1>
          <div id="stepOneForm" className="form-block">
            <div className="registerinfo">Ваше ім'я</div>
            <form>
              <ValidatorForm
                ref="form"
                onSubmit={(e) => this.buttonNext()}
                onError={(errors) => console.log(errors)}
              >
                <InputMask
                  mask="+38 (099) 999-99-99"
                  value={this.props.store.userDataReducer.phone}
                  onChange={(e) =>
                    this.props.dispatch(
                      UserActions.set_phone(
                        e.target.value.replace(/[\s\-()]+/g, "").replace("+38", ""),
                      ),
                    )
                  }
                >
                  {(inputProps) => (
                    <TextValidator
                      {...inputProps}
                      label="Телефон"
                      name="phone"
                      variant="outlined"
                      className="stepOneField"
                      validators={["required", "PhoneChecker"]}
                      errorMessages={[
                        "Вкажіть номер телефону. Наприклад: +38 (093) 123-45-67",
                        "Вкажіть номер телефону. Наприклад: +38 (093) 123-45-67",
                      ]}
                    />
                  )}
                </InputMask>

                <TextValidator
                  value={this.props.store.userDataReducer.fio}
                  label="Имя"
                  name="name"
                  className="stepOneField"
                  variant="outlined"
                  onChange={(e) => this.props.dispatch(UserActions.set_fio(e.target.value))}
                  validators={["required", "RussianSymbolsChecker"]}
                  errorMessages={[
                    "Вкажіть Ваше ім'я українською мовою",
                    "Вкажіть Ваше ім'я українською мовою",
                  ]}
                />

                <Button type="submit" className="MuiButtonMew" id="firstStepNext">
                  Далі
                </Button>
              </ValidatorForm>
            </form>
          </div>
        </div>
        <Footer />
        <Spinner isLoading={this.state.isLoading} />
      </div>
    );
  }
}

export default connect((state) => ({ store: state }))(StepOne);



// WEBPACK FOOTER //
// src/pages/registration/stepOne.js